let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("koL5r")).then(() => parcelRequire('kxR7V'));